import { Component, OnInit } from '@angular/core';

@Component({
  selector: "app-startingpoint",
  templateUrl: "./startingpoint.component.html",
  styleUrls: ["./startingpoint.component.css"],
})
export class StartingpointComponent implements OnInit {
  constructor() {}
  currentYear: number = new Date().getFullYear();

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/startingpoint/startingpoint.component.ts